export default __webpack_public_path__ + "static/media/erPhotographer.7cc8d975.png";